module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header-holder"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "logo text-uppercase"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('img', {
    staticClass: "custom-logo",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": "/static/images/p_pedersen_logo.png"
    }
  })])], 1), _vm._v(" "), _c('a', {
    staticClass: "nav-opener",
    on: {
      "click": _vm.mobileMenuToggle
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('nav', {
    class: {
      'mobile-show': this.showMobileMenu
    },
    attrs: {
      "id": "nav"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "has-children",
    class: {
      'active': _vm.$route.name.includes('Products')
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "children-list"
  }, [_c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsStykgods'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsStykgods'
      }
    }
  }, [_vm._v("\n                                    Stykgods / Partigods\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsHellast'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsHellast'
      }
    }
  }, [_vm._v("\n                                    Hellast / Full load\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsBulk'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsBulk'
      }
    }
  }, [_vm._v("\n                                    Bulk\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsKoel'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsKoel'
      }
    }
  }, [_vm._v("\n                                    Køl / Frys\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsFarligt'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsFarligt'
      }
    }
  }, [_vm._v("\n                                    Farligt gods / ADR\n                                ")]), _vm._v(" "), _c('router-link', {
    class: {
      'selected': _vm.$route.name === 'ProductsFragtfirma'
    },
    attrs: {
      "tag": "li",
      "to": {
        name: 'ProductsFragtfirma'
      }
    }
  }, [_vm._v("\n                                    Fragtfirma\n                                ")])], 1)]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === '???'
    }
  }, [_c('a', {
    attrs: {
      "href": "/#miljo"
    }
  }, [_vm._v("\n                                Miljø\n                            ")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'Covid'
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Covid'
      }
    }
  }, [_vm._v("\n                                COVID-19\n                            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'About'
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v("\n                                Hvem er vi\n                            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'Contact'
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("\n                                Kontakt os\n                            ")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n                                Transport\n                                "), _c('i', {
    staticClass: "fas fa-caret-down fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff13103"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
// module id = 272
// module chunks = 1